import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

const Footer = () => {
  return (
    <>
      {/* <footer className="text-white py-4 mt-5" style={{ background: '#333' }}>
        <div className="container-small">
          <Container>
            <Row className="text-center text-md-start d-flex flex-column flex-md-row align-items-center justify-content-between">
              <Col xs={12} md={4} className="mb-3 mb-md-0">
                <p className="mb-0 text-white text-center text-md-start text-sm">
                  Property by Phone
                </p>
              </Col>

              <Col xs={12} md={8} className="mb-3 mb-md-0">
                <ul className="list-unstyled d-flex flex-column flex-md-row gap-3 align-items-center justify-content-center justify-content-md-end m-0 p-0">
                  <li>
                    <a href="/" className="text-white text-decoration-none">
                      Pricing
                    </a>
                  </li>
                  <li>
                    <a
                      href="/contact"
                      className="text-white text-decoration-none"
                    >
                      Contact Us
                    </a>
                  </li>
                  <li>
                    <a
                      href="/about"
                      className="text-white text-decoration-none"
                    >
                      About Us
                    </a>
                  </li>
                  <li>
                    <a href="/faq" className="text-white text-decoration-none">
                      FAQ
                    </a>
                  </li>
                  <li>
                    <a
                      href="/privacy-policy"
                      className="text-white text-decoration-none"
                    >
                      Privacy Policy
                    </a>
                  </li>
                  <li>
                    <a
                      href="/terms-of-use"
                      className="text-white text-decoration-none"
                    >
                      Terms of Use
                    </a>
                  </li>
                </ul>
              </Col>
            </Row>
          </Container>
        </div>
      </footer> */}

      {/* Copyright Footer */}
      <footer className="bg-dark text-white py-2">
        <Container>
          <Row className="text-center">
            <Col className='mt-2'>
              <p>© All rights reserved 2025</p>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
};

export default Footer;
